function PowerBIMasterSales() {
  let user = localStorage.getItem("Username");

  function handleTroll(e) {
    e.preventDefault();
    window.open("https://www.youtube.com/watch?v=dQw4w9WgXcQ", "_blank");
  }

  return (
    <>
      {/* {user === "curtis@investin.org" ||
      user === "richardlawless@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <button
            onClick={(e) => handleTroll(e)}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Open PowerBI
          </button>
        </div>
      ) : (
        <> </>
      )} */}
      {user === "curtis@investin.org" ||
      user === "mariana@investin.org" ||
      user === "hitesh@investin.org" ||
      user === "shameer@investin.org" ||
      user === "rebecca@investin.org" ||
      user === "richardlawless@investin.org" ||
      user === "rebeccaseymour@investin.org" || 
      user === "carla.jones@dukesplus.com" ||
      user === "shu@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          Master Sales: IP
          <iframe
            title="MasterSales IP"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=d5fb10d6-29e1-437e-9259-085f15c21b32&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <> </>
      )}
      {user === "curtis@investin.org" ||
      user === "rebecca@investin.org" ||
      user === "richardlawless@investin.org" ||
         user === "rebeccaseymour@investin.org" ||
user === "carla.jones@dukesplus.com" ||
         
      user === "shu@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
         IP Costs
          <iframe
            title="IP Costs"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=b1c14dd8-1f72-4f83-b2ea-f38e9dca9ac4&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <> </>
      )}
      <br></br>
      <br></br>
      <br></br>
      {user === "curtis@investin.org" ||
      user === "willow@investin.org" ||
      user === "hitesh@investin.org" ||
      user === "shameer@investin.org" ||
      user === "orla@investin.org" ||
      user === "hannah@investin.org" ||
      user === "lillywalker@investin.org" ||
      user === "emilylaycock@investin.org" ||
      user === "caitlinellis@investin.org" ? (
        <div style={{ width: "90%", height: "90%" }}>
          Master Sales: GSP
          <iframe
            title="MasterSales GSP"
            style={{ width: "100%", height: "100%" }}
            src="https://app.powerbi.com/reportEmbed?reportId=abb37f68-abac-4895-848c-59bb049349f0&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      ) : (
        <> </>
      )}
      <br></br>
      <br></br>
      <div style={{ width: "90%", height: "90%" }}>
        Master Sales: General
        <iframe
          title="MasterSales"
          style={{ width: "100%", height: "100%" }}
          src="https://app.powerbi.com/reportEmbed?reportId=3b1dca9f-3169-4c44-b37e-ef7626831f15&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
      <br></br>
      <br></br>
      <br></br>
    </>
  );
}

export default PowerBIMasterSales;
